import { ref, computed, watch, Ref, SetupContext } from '@vue/composition-api'
import { debounce } from '../utils'
import { ContentRect } from '@bpchart/types/dom'

// @Q@ 雖然已經有建 .d.ts了，但實際 import到專案後還是有 error，所以這邊也還是加上來
declare class ResizeObserver {
    constructor (callback: (entries: any, observer: any) => void)
    observe(target: Element): void;
    unobserve(target: Element): void;
    disconnect(): void;
  }

export default function useObserverResize (dom: HTMLElement) {
  const contentRect: Ref<ContentRect | undefined> = ref({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  })
  const debounceResize = debounce((entries) => {
    const entry = entries[0]
    contentRect.value = entry.contentRect
  })
  const observer = new ResizeObserver((entries: any, observer: any) => {
    // 初始值不做emit
    // if (isMounted) {
      debounceResize(entries)
    // }
  })
  observer.observe(dom)

  return contentRect
}